import { NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'gea-hrt-heading',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadingComponent {
  readonly text = input<string>();
  readonly type = input<'main' | 'sub' | 'minor' | 'tiny'>('main');
  readonly disabled = input(false);
  readonly blur = input(false);
}
